import { api } from '../../../../redux/setupAxios';
import { dateToTimestamp } from '../../../helper';

export const REPORT_URL = 'report';

export async function getReport({ from, to, ...params }) {
	from = dateToTimestamp(from, 0);
	to = dateToTimestamp(to, Date.now());

	try {
		const { data } = await api.get(`${REPORT_URL}`, {
			params: {
				from,
				to,
				...params,
			},
		});
		return data;
	} catch (e) {
		console.error(e);
		return [];
	}
}

export function hideOrShowReport(reportId, reportType, action) {
	return api.post(`${REPORT_URL}`, { reportId, reportType, action });
}

export function banUser(userId, reportId) {
	return api.post(`${REPORT_URL}/ban/user`, { userId, reportId });
}

export function banReport(reportId, reportType, action, params) {
	return api.post(`${REPORT_URL}/ban/report`, {
		reportId,
		reportType,
		action,
		...params,
	});
}

export function banReports(reportIds, action) {
	return api.post(`${REPORT_URL}/ban/reports`, {
		action,
		reportIds,
	});
}
